import type {AttachedImage, AttachedMedia, AttachedVideo} from 'sweet-types';

export function getFilename(path: string): string {
  return path.split('/').pop() || '';
}

export function hasContent(val: any): val is string {
  return typeof val === 'string' && Boolean(val) && val !== '';
}

export function isMediaImage(media: AttachedMedia): media is AttachedImage {
  return 'image_ref' in media && hasContent(media.image_ref);
}

export function isMediaVideo(media: AttachedMedia): media is AttachedVideo {
  return 'embed_ref' in media && hasContent(media.embed_ref);
}
